module.exports = __webpack_public_path__ + "media/images/emblems/Rudolfstetten-blason-7fa08f7c2c9e5832e8603d3060b1248e.png";